export default "__VITE_ASSET__B4etZ24$__"